import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"
import { IDadosRetornoEscalacaoFranquiaListaAmericana } from "../franquia/FranquiaService";

export interface IDisputa {
    codigo: number;
    nome: string;
    codigo_liga: number;
}

export interface ILstDisputaTable {
    codigo?: number;
    conferencia: IDadosConferencia[];
    divisao: IDivisao[];
    dtSorteio?: Date;
}


export interface ILstDisputaDados {
    aprovacao_Restrito: string;
    cap_Maximo: string;
    cap_Minimo: string;
    conf1_divisao1: string;
    conf1_divisao2: string;
    conf1_divisao3: string;
    conf1_divisao4: string;
    conf2_divisao1: string;
    conf2_divisao2: string;
    conf2_divisao3: string;
    conf2_divisao4: string;
    conferencia1: string;
    conferencia2: string;
    codigo_conf1_divisao1: number;
    codigo_conf1_divisao2: number;
    codigo_conf1_divisao3: number;
    codigo_conf1_divisao4: number;
    codigo_conf2_divisao1: number;
    codigo_conf2_divisao2: number;
    codigo_conf2_divisao3: number;
    codigo_conf2_divisao4: number;
    codigo_conferencia1: number;
    codigo_conferencia2: number;
    criacao_All_Star_Game_Liga: boolean;
    dtFLeilao_Termino: string;
    dtFreeAgency_Inicio: string;
    dtFreeAgency_Termino: string;
    dtLeilao_Inicio: string;
    dtLimites_Inicio: string;
    dtLimites_Termino: string;
    enf_Mais_Vezes_Conferencia: boolean;
    enf_Mais_Vezes_Divisao: boolean;
    hora_Leilao: string;
    lance: string;
    max_Jogadores: string;
    melhorDePlayIn: boolean;
    melhorDePlayOffs: number;
    min_Jogadores: string;
    min_Posicao: string;
    quantidade_Rodadas: number;
    tempo_Dias: string;
    tipo: string;
    free_Agency: IDadosFreeAgency;
    leilao: IDadosLeilao;
    configuracao_Liga: IDadosConfiguracaoLiga;
    liberacoes_Liga: IDatosEstouro_Cap;
    data_Sorteio_Franquia?: Date;
    configuracao_Calendario_Liga: IDadosConfiguracaoCalendario;
}


export interface IDatosEstouro_Cap {
    baixo_Min_Cap: boolean;
    estouro_Cap: boolean;
    baixo_Min_Jog: boolean;
    estouro_Max_Jog: boolean;
    baixo_Min_Pos: boolean;
    data_Inicio?: string | null;
    data_Fim?: string | null;
    data_Sorteio_Franquia?: Date;
    situacao: boolean;
    codigo_Temporada: number;
    data_Sorteio_Franquia_Draft_Inicial?: Date;
    data_Sorteio_Franquia_Draft_Calouro?: Date;
    escolha_Espelhada_Draft_Calouro: boolean;

}


export interface ILstDisputaTableAdd {
    codigo?: number;
    conferencia: string;
    divisao: string;
    franquia: string;
}

interface IDivisao {
    nome: string;
}

export interface IDadosDisputaRetorno {
    dado: IDetalheDisputaLiga;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDetalheDisputaLiga {
    codigo_Liga: number;
    conferencia: IDadosConferencia[];
    free_Agency?: IDadosFreeAgency | null;
    leilao?: IDadosLeilao | null;
    codUsuCriacao: number;
    codUsuModificacao: number;
    atualizar_Conferencia: boolean;
    franquia: IDadosFranquiaDisputa[];
    liberacoes_Liga: IDatosEstouro_Cap;
    atualizar_Franquia: boolean;
    atualizar_Calendario: boolean;
    data_Sorteio_Franquia?: Date;
    calendario: IDadosCalendario[];
    configuracao_Calendario_Liga: IDadosConfiguracaoCalendario;
    franquias_Picks_Rodada_Inicial: IDadosEscolhas[];
    atualizar_franquias_Picks_Rodada_Inicial: boolean;
    configuracao_Liga: IDadosConfiguracaoLiga;
    franquias_Picks: IDadosEscolhasCalouro[];
    atualizar_franquias_Picks: boolean;
    atualizar_Leilao: boolean;
    atualizar_Situacao_Calouro: boolean;
    atualizar_Situacao_Inicial: boolean;
}

export interface IDadosConfiguracaoLiga {
    situacao_Mercado: boolean;
    data_Abertura_Mercado?: string | null;
    data_Encerramento_Mercado?: string | null;
    situacao_Calouro: boolean;
    data_Abertura_Calouro?: string | null;
    data_Encerramento_Calouro?: string | null;
    periodo_Util_Final_Calouro?: string;
    periodo_Util_Inicial_Calouro?: string;
    situacao_Inicial: boolean;
    data_Abertura_Inicial?: string | null;
    data_Encerramento_Inicial?: string | null;
    periodo_Util_Final_Inicial?: string;
    periodo_Util_Inicio_Inicial?: string;
    sem_Relogio_Calouro: boolean;
    tempo_Escolha_Calouro?: number;
    sem_Relogio_Inicial: boolean;
    tempo_Escolha_Inicial?: number;
    situacao_Troca_Posicao: boolean;
    data_Abertura_Troca_Posicao?: string | null;
    data_Encerramento_Troca_Posicao?: string | null;
}


export interface IDadosConfiguracaoCalendario {
    all_Star_Game_Liga: boolean;
    codUsuCriacao?: number;
    codigo?: number;
    codigo_Liga?: number;
    dtCriacao?: string;
    enfrentar_Mais_Vezes_Conferencia: boolean;
    enfrentar_Mais_Vezes_Divisao: boolean;
    play_In: boolean;
    quantidade_Rodadas: number;
    quantidade_Rodadas_Play_Offs: number;
}

export interface IDadosCalendario {
    codigo?: number;
    rodada: number;
    placar_Mandante?: number;
    placar_Visitante?: number;
    play_Offs?: number;
    codigo_Franquia_Mandante: number;
    codigo_Franquia_Visitante: number;
    empate: boolean;
    vencedor_Mandante: boolean;
    vencedor_Visitante: boolean;
    status_Jogo: boolean;
    rodada_Atual: boolean;
    copinha: boolean;
}


export interface IDadosFranquiaDisputa {
    codigo_Conferencia?: number;
    nome_Conferencia?: string;
    codigo_Divisao?: number;
    nome_Divisao?: string;
    codigo_Franquia?: number;
    nome_Franquia?: string;
}

export interface IDadosFreeAgency {
    codigo?: number;
    codigo_Liga?: number;
    codigo_Temporada?: number;
    data_Abertura?: string | null;
    data_Encerramento?: string | null;
    tempo_Duracao?: number;
    tempo_Restrito?: number;
    situacao: boolean;
    codUsuCriacao?: number;
    dtCriacao?: Date;

}
export interface IDadosLeilao {
    codigo?: number;
    codigo_Liga?: number;
    codigo_Temporada?: number;
    data_Abertura?: string | null;
    data_Encerramento?: string | null;
    hora_Virada: string;
    tempo_Duracao: number;
    situacao: boolean;
    codUsuCriacao?: number;
    dtCriacao?: Date;

}

export interface IDadosConferencia {
    codigo?: number;
    nome: string;
    codUsuCriacao?: number;
    divisao: IDadosDivisao[];
    dtCriacao?: Date;

}

export interface IDadosDivisao {
    codigo: number;
    nome: string;
    codigo_Conferencia?: number;
    codUsuCriacao?: number;
    dtCriacao?: Date;
}


export interface IDetalheDisputa {
    codigo_Liga: number;
    codigo_Temporada: number;
    conferencia: IDadosConferencia[];
    free_Agency: IDadosFreeAgency;
    leilao?: IDadosLeilao;
    codUsuCriacao: number;
    liberacoes_Liga: IDatosEstouro_Cap;
}

export interface IDadosFranquia {
    codigo: number;
    nome: string;
    situacao: number;
    logo: string;
    capacidade_Maxima: string;
    espaco_Maximo: string;
    uniforme: string; //imagem
    codigo_Divisao: number;
    comissario: boolean;
}

export interface IDadosFranquiaNba {
    codigo: number;
    nome: string;
    logo: string;
    cap_Maximo: string;
    espaco_Maximo: string;
    uniforme: string; //imagem
    codigo_Divisao: number;
    data: Date;

}

export interface IDadosJogosNba {
    codigo: number;
    franquias: IDadosFranquiaNba[];
    data: Date;
}


export interface IListagemDisputa {
    codigo: number;
    nome_Liga: string;
    codigo_liga: number;
    rodada: number;
    franquia_Mandante: IDadosFranquia;
    franquia_Visitante: IDadosFranquia;
    situacao: number;
}

export interface IDadosRetornoDisputa {
    dado: IListagemDisputa;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IGridColumnHeaderParamsStats {
    codigo: number;
    stats: string;
    descricao: string;

}



type TDisputasComTotalCount = {
    data: IDadosRetornoDisputa;
    totalCount: number;
}

export interface IDadosRetornoEscalacaoConfronto {
    dado: IRetornoEscalacaoDisputaConfronto;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoEscalacaoConfrontoPontuacao {
    dado: IRetornoEscalacaoDisputaConfrontoPontuacao;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IRetornoEscalacaoDisputaConfrontoPontuacao {
    franquia_Mandante: IDadosFranquia;
    franquia_Visitante: IDadosFranquia;
    estatistica_Jogadores_Franquia_Mandante: IDadosEstatistica[];
    estatistica_Jogadores_Franquia_Visitante: IDadosEstatistica[];
    placar_Mandante: number;
    placar_Visitante: number;
    empate: boolean;
    vencedor_Mandante: boolean;
    vencedor_Visitante: boolean;
    rodada: number;
    status_Jogo: boolean;
    criterio_Desempate: IDadosCriteriosDesempate[];
    codigo_Tipo_Posicao_Confronto: number;
}

export interface IRetornoEscalacaoDisputaConfronto {
    franquia_Mandante: IDadosFranquia;
    franquia_Visitante: IDadosFranquia;
    detalhes_Estatistica_Jogadores_Franquia_Mandante: IDadosEstatisticaJogadoresPosicao;
    detalhes_Estatistica_Jogadores_Franquia_Visitante: IDadosEstatisticaJogadoresPosicao;
    detalhes_Estatistica_Jogadores_Franquia_Mandante_Original: IDadosEstatisticaJogadoresPosicao;
    detalhes_Estatistica_Jogadores_Franquia_Visitante_Original: IDadosEstatisticaJogadoresPosicao;
    detalhes_Estatistica_Jogadores_Franquia_Mandante_Reserva: IDadosRetornoEscalacaoFranquiaListaAmericana[];
    detalhes_Estatistica_Jogadores_Franquia_Visitante_Reserva: IDadosRetornoEscalacaoFranquiaListaAmericana[];
    placar_Mandante: number;
    placar_Visitante: number;
    empate: boolean;
    vencedor_Mandante: boolean;
    vencedor_Visitante: boolean;
    rodada: number;
    status_Jogo: boolean;
    criterio_Desempate: IDadosCriteriosDesempate[];
    codigo_Tipo_Posicao_Confronto: number;
}

export interface IDadosCriteriosDesempate {
    codigo: number;
    ordem: number;
    nome: string;
    descricao: string;
}

export interface IDadosEstatisticaJogadoresPosicao {
    estatistica_Jogadores_PG: IDadosEstatistica[];
    estatistica_Jogadores_SG: IDadosEstatistica[];
    estatistica_Jogadores_PF: IDadosEstatistica[];
    estatistica_Jogadores_SF: IDadosEstatistica[];
    estatistica_Jogadores_C: IDadosEstatistica[];
    estatistica_Jogadores_RG: IDadosEstatistica[];
    estatistica_Jogadores_RF: IDadosEstatistica[];
    estatistica_Jogadores_RC: IDadosEstatistica[];
    estatistica_Jogadores_Sexto_Homem: IDadosEstatistica[];
    estatistica_Jogadores_Primeiro_G: IDadosEstatistica[];
    estatistica_Jogadores_Segundo_G: IDadosEstatistica[];
    estatistica_Jogadores_Primeiro_F: IDadosEstatistica[];
    estatistica_Jogadores_Segundo_F: IDadosEstatistica[];
    estatistica_Jogadores_Setimo_Homem: IDadosEstatistica[];
    estatistica_Jogadores_Oitavo_Homem: IDadosEstatistica[];
    estatistica_Jogadores_Nono_Homem: IDadosEstatistica[];
    estatistica_Jogadores_Decimo_Homem: IDadosEstatistica[];
    estatistica_Jogadores_Quinto_Homem: IDadosEstatistica[];
    estatistica_Jogadores_Primeiro_G_Lista_Americana: IDadosEstatistica[];
    estatistica_Jogadores_Segundo_G_Lista_Americana: IDadosEstatistica[];
    estatistica_Jogadores_Primeiro_F_Lista_Americana: IDadosEstatistica[];
    estatistica_Jogadores_Segundo_F_Lista_Americana: IDadosEstatistica[];
}


export interface IDadosRetornoDisputaConfronto {
    dado: IDisputaConfronto;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDisputaConfronto {
    franquia_Mandante: IDadosFranquia;
    franquia_Visitante: IDadosFranquia;
    estatistica_Jogadores_Franquia_Mandante: IDadosEstatistica[];
    estatistica_Jogadores_Franquia_Visitante: IDadosEstatistica[];
    placar_Mandante: number;
    placar_Visitante: number;
    rodada: number;
}

export interface IDadosEscalacaoOriginao {
    codigo?: number;
    ordem?: number;
    posicao?: string;
    posicao_Liga?: string;
    nome_Titular?: string;
    nome_Reserva_1?: string;
    nome_Reserva_2?: string;
    foto_Titular?: string;
    foto_Reserva_1?: string;
    foto_Reserva_2?: string;
}

export interface IDadosEstatistica {
    codigo: number;
    codigo_NBA: string;
    nome: string;
    nome_Franquia_NBA_Adversaria: string;
    nome_Franquia_NBA: string;
    data_Inicio_Jogo_NBA: string;
    logo_Franquia_NBA_Adversaria: string;
    foto: string;
    minutos_PG?: number;
    minutos_SG?: number;
    minutos_SF?: number;
    minutos_PF?: number;
    minutos_C?: number;    
    ast?: number;
    blk?: number;
    dreb?: number;
    fga?: number;
    fgm?: number;
    fgmp?: number;
    fta?: number;
    ftm?: number;
    ftmp?: number;
    min?: number;
    mplu?: number
    ordem: number;
    oreb?: number;
    peso_Total_Jogador?: number;
    pf?: number;
    posicao_Liga: string;
    posicao_Original: string;
    pts?: number;
    quantidade_Jogos?: number;
    reb?: number;
    stl?: number;
    threepa?: number;
    threepm?: number;
    threepmp?: number;
    to?: number;
    fgM_Informativo: number;
    fgA_Informativo: number;
    ftM_Informativo: number;
    ftA_Informativo: number;
    threepM_Informativo: number;
    threepA_Informativo: number;
    setimo_Homem: boolean;
    oitavo_Homem: boolean;
    nono_Homem: boolean;
    decimo_Homem: boolean;
    fte?: number;
    fge?: number;
    threepe?: number;
    stocks?: number;
    tipoDesempate?: number; //7,8,9,10

}

export interface IDadosDisputaRetornoCalendario {
    dado: IDadosCalendario[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


export interface IDadosCalendarioAnterior {
    dado: IDadosCalendario;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosClassificacao {
    codigo?: number;
    codigo_Liga: number;
    codigo_Franquia: number;
    codigo_Conferencia?: number;
    codigo_Divisao?: number;
    codigo_Temporada?: number;
    nome_Franquia: string;
    quantidade_Vitorias: number;
    quantidade_Empates: number;
    quantidade_Derrotas: number;
    pontos: number;
    pontuacao_Stats: number;
    saldo: number;
    logo_Franquia: string;
    posicao: number;
    posicao_Anterior: number;
    saldo_Vitorias: number; 
    vitorias_Conferencia: number; 
    vitorias_Divisao: number;
}

export interface IDadosClassificacaoGeral {
    classificacao_Geral: IDadosClassificacao[];
}

export interface IDadosClassificacaoConferencia {
    nome_Conferencia1: string;
    nome_Conferencia2: string;
    codigo_Conferencia1: number;
    codigo_Conferencia2: number;
    classificacao_Conferencia1: IDadosClassificacao[];
    classificacao_Conferencia2: IDadosClassificacao[];
}

export interface IDadosClassificacaoDivisao {
    nome_Divisao1: string;
    codigo_Divisao1: number;
    nome_Divisao2: string;
    codigo_Divisao2: number;
    nome_Divisao3: string;
    codigo_Divisao3: number;
    nome_Divisao4: string;
    codigo_Divisao4: number;
    nome_Divisao5: string;
    codigo_Divisao5: number;
    nome_Divisao6: string;
    codigo_Divisao6: number;
    nome_Divisao7: string;
    codigo_Divisao7: number;
    nome_Divisao8: string;
    codigo_Divisao8: number;
    classificacao_Divisao1: IDadosClassificacao[];
    classificacao_Divisao2: IDadosClassificacao[];
    classificacao_Divisao3: IDadosClassificacao[];
    classificacao_Divisao4: IDadosClassificacao[];
    classificacao_Divisao5: IDadosClassificacao[];
    classificacao_Divisao6: IDadosClassificacao[];
    classificacao_Divisao7: IDadosClassificacao[];
    classificacao_Divisao8: IDadosClassificacao[];

}

export interface IDadosRetornoClassificacoes {
    classificacao_Geral: IDadosClassificacaoGeral;
    classificacao_Conferencia: IDadosClassificacaoConferencia;
    classificacao_Divisao: IDadosClassificacaoDivisao;

}

export interface IRetornoClassificacoes {
    dado: IDadosRetornoClassificacoes;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IRetornoClassificacaoCopinha {
    dado: IDadosRetornoClassificacoesCopinha;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoClassificacoesCopinha {
    grupos: IDadosClassificacaoGeralCopinha[];
}

export interface IDadosClassificacaoGeralCopinha {
    codigo: number;
    nome: string;
    classificacao: IDadosClassificacao[];
}

export interface IRetornoDadosEscolha {
    dado: IDadosEscolhas[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosEscolhas {
    escolha_Inicial: number;
    posicao_Geral: string;
    codigo_Franquia?: number;

}

export interface IRetornoDadosEscolhaCalouro {
    dado: IDadosEscolhasCalouro[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosEscolhasCalouro {
    codigo?: number;
    posicao_Final: number;
    posicao_Geral: string;
    codigo_Franquia: number;
    espelhada: boolean;

}

export interface IDadosAtualizarDisputaLiga {
    codigo_Liga: number;
    escolha_Espelhada_Draft_Calouro: boolean;
    codigo_Usuario: number;
}

export interface IDadosRetornoSorteioInicial {
    dado: IDaddosDraftSorteioInicial;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDaddosDraftSorteioInicial {
    data_Proximo_Sorteio: Date;
    sorteio_Finalizado: boolean;
    sorteio_Realizado: boolean;
    espelhada: boolean;
    informacoes_Loteria: IDetalheDraftSorteioPicks[]
}

export interface IDetalheDraftSorteioPicks {
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Pick: number;
    posicao_Final: number;
    numero_Sorteado?: number;
    data_Liberacao: Date;
    calouro: boolean;
    codigo_Franquia_Original: string;
    nome_Franquia_Original: string;
    logo_Franquia_Original: string;
    codigo_Franquia_Dono: string;
    nome_Franquia_Dono: string;
    logo_Franquia_Dono: string;
}

export interface IDadosSorteioCalouro {
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Usuario: number;
    espelhada: boolean;
}

export interface IDadosCalendarioQuantidadeRodada {
    dado: number;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


export interface IDadosCalendarioCopinhaRodadas {
    dado: number[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosCopinha {
    codigo_Liga: number;
    nome_Liga: string;
    logo_Liga?: string;
    caminho_Logo?: string;
    codigo_Temporada: number;
    descricao_Temporada: string;
    grupos: IDadosCopinhaGrupo[];
}

export interface IDadosCopinhaGrupo {
    codigo: number
    nome: number;
    franquias: IDadosCopinhaGrupoFranquias[];
}

export interface IDadosCopinhaGrupoFranquias {
    codigo?: number;
    nome?: string;
    logo?: string;
    caminho_Logo?: string;
}

export interface IRetornoDadosSorteioCopinha {
    dado: IDadosCopinha;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

const getAllPorCodigoLiga = async (codigo: number): Promise<IDadosDisputaRetorno> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosDisputaRetorno>(`/disputa/liga/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getEscolhasPorCodigoLiga = async (codigoLiga: number): Promise<IRetornoDadosEscolha> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IRetornoDadosEscolha>(`/draft/escolhas/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDisputasPorRododa = async (codigo_franquia = 0, rodada = 0): Promise<TDisputasComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/disputa/dados/rodada/${codigo_franquia}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}


const getEscalacaoDisputasPorCodigoCalendario = async (codigoCalendario = 0): Promise<IDadosRetornoEscalacaoConfronto> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoConfronto>(`/liga/jogo/detalhes/${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getEscalacaoDisputasPorCodigoCalendarioMandante = async (codigoCalendario = 0): Promise<IDadosRetornoEscalacaoConfronto> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoConfronto>(`/liga/jogo/detalhes/mandante${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const getEscalacaoDisputasPorCodigoCalendarioVisitante = async (codigoCalendario = 0): Promise<IDadosRetornoEscalacaoConfronto> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoConfronto>(`/liga/jogo/detalhes/visitante${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getEscalacaoDisputasPorCodigoCalendarioOriginal = async (codigoCalendario = 0): Promise<IDadosRetornoEscalacaoConfronto> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoConfronto>(`/liga/jogo/detalhes/original/${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getEscalacaoDisputasPorCodigoCalendarioPontuacao = async (codigoCalendario = 0): Promise<IDadosRetornoEscalacaoConfrontoPontuacao> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoConfrontoPontuacao>(`/liga/jogo/detalhes/pontuacao/${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getEscalacaoDisputasPorCodigoCalendarioPontuacaoPlayOffs = async (codigoCalendario = 0): Promise<IDadosRetornoEscalacaoConfrontoPontuacao> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoConfrontoPontuacao>(`/liga/jogo/detalhes/playoff/pontuacao/${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getEscalacaoDisputasPorCodigoCalendarioPlayoffs = async (codigoCalendario = 0): Promise<IDadosRetornoEscalacaoConfronto> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEscalacaoConfronto>(`/liga/jogo/detalhes/playoffs/${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const getById = async (codigo: number): Promise<IDetalheDisputa> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDetalheDisputa>(`/disputa/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getCalendarioPorCodigoLigaTemporada = async (codigo: number, codigoTemporada: number): Promise<IDadosDisputaRetornoCalendario> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosDisputaRetornoCalendario>(`/liga/calendario/${codigo}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getCalendarioCopinhaPorCodigoLigaTemporada = async (codigo: number, codigoTemporada: number): Promise<IDadosDisputaRetornoCalendario> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosDisputaRetornoCalendario>(`/liga/calendario/copinha/${codigo}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getCalendarioPorRodada = async (codigo: number, codigoTemporada: number, rodada: number): Promise<IDadosDisputaRetornoCalendario> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosDisputaRetornoCalendario>(`/liga/calendario/rodada/${codigo}/${codigoTemporada}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getCalendarioCopinhaPorRodada = async (codigo: number, codigoTemporada: number, rodada: number): Promise<IDadosDisputaRetornoCalendario> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosDisputaRetornoCalendario>(`/liga/calendario/rodada/copinha/${codigo}/${codigoTemporada}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getCalendarioAnterior = async (codigoLiga: number, codigoTemporada: number, codigoRodada: number, codigoFranquia: number): Promise<IDadosCalendarioAnterior> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosCalendarioAnterior>(`/liga/calendario/anterior/${codigoLiga}/${codigoTemporada}/${codigoRodada}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getCalendarioAnteriorPlayOffs = async (codigoLiga: number, codigoTemporada: number, codigoFranquia: number): Promise<IDadosCalendarioAnterior> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosCalendarioAnterior>(`/liga/calendario/anterior/playoffs/${codigoLiga}/${codigoTemporada}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}


const getClassificacaoPorCodigoLigaTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<IRetornoClassificacoes> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IRetornoClassificacoes>(`/franquia/classificacao/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getClassificacaoCopinhaPorCodigoLigaTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<IRetornoClassificacaoCopinha> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IRetornoClassificacaoCopinha>(`/franquia/classificacao/copinha/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const getEscolhasCalouroPorCodigoLiga = async (codigoLiga: number): Promise<IRetornoDadosEscolhaCalouro> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IRetornoDadosEscolhaCalouro>(`/draft/escolhas/calouro/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const Create = async (dados: Omit<IDetalheDisputaLiga, "codigo">): Promise<number> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/disputa`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;

}

const updateById = async (dados: IDetalheDisputaLiga): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.put<IDetalheDisputa>(`/disputa`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const deleteById = async (codigo: number): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.delete(`/disputa/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const updateRodadaEspelhadaCalouroById = async (codigoLiga: number, escolhaEspelhada: boolean): Promise<void> => {
    const user = CookieService.get("access_user");
    let dados: IDadosAtualizarDisputaLiga = {
        codigo_Liga: codigoLiga,
        escolha_Espelhada_Draft_Calouro: escolhaEspelhada,
        codigo_Usuario: user.codUsuario
    }
    const token = CookieService.get("access_token");
    await Api.put<IDetalheDisputa>(`/disputa/calouro/escolhaespelhada`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const getDraftSorteioCalouroById = async (codigoLiga: number): Promise<IDadosRetornoSorteioInicial> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoSorteioInicial>(`/draft/calouro/sorteio/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateSorteioCalouro = async (dados: IDadosSorteioCalouro): Promise<void> => {
    const token = CookieService.get("access_token");
    //const user = CookieService.get("access_user");

    //dados = { ...dados, codigo_Usuario: user.codUsuario };

    await Api.put<IDadosSorteioCalouro>(`/draft/calouro/sorteio`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


const getCalendarioFranquia = async (codigo: number, codigoTemporada: number, codigoFranquia: number): Promise<IDadosDisputaRetornoCalendario> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosDisputaRetornoCalendario>(`/liga/calendario/franquia/${codigo}/${codigoTemporada}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}


const getCalendarioQuantidadeRodadaPorTemporada = async (codigo: number, codigoTemporada: number): Promise<IDadosCalendarioQuantidadeRodada> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosCalendarioQuantidadeRodada>(`/liga/calendario/quantidaderodada/${codigo}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getCalendarioRodadasCopinhaPorTemporada = async (codigo: number, codigoTemporada: number): Promise<IDadosCalendarioCopinhaRodadas> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosCalendarioCopinhaRodadas>(`/liga/calendario/copinha/rodadas/${codigo}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}


const updateSorteioCopinhaById = async (codigoLiga: number, codigoTemporada: number): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");

    await Api.put(`/disputa/copinha/sorteio/${codigoLiga}/${codigoTemporada}/${user.codUsuario}`, null, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}



const getDadosCopinhaPorCodigoLigaTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<IRetornoDadosSorteioCopinha> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get<IRetornoDadosSorteioCopinha>(`/disputa/copinha/grupo/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


export const DisputaService = {
    getDisputasPorRododa,
    getById,
    getAllPorCodigoLiga,
    Create,
    updateById,
    deleteById,
    getCalendarioPorCodigoLigaTemporada,
    getClassificacaoPorCodigoLigaTemporada,
    getEscalacaoDisputasPorCodigoCalendario,
    getEscolhasPorCodigoLiga,
    getEscolhasCalouroPorCodigoLiga,
    updateRodadaEspelhadaCalouroById,
    getCalendarioAnterior,
    getEscalacaoDisputasPorCodigoCalendarioPlayoffs,
    getCalendarioAnteriorPlayOffs,
    updateSorteioCalouro,
    getDraftSorteioCalouroById,
    getEscalacaoDisputasPorCodigoCalendarioPontuacao,
    getEscalacaoDisputasPorCodigoCalendarioPontuacaoPlayOffs,
    getEscalacaoDisputasPorCodigoCalendarioOriginal,
    getCalendarioPorRodada,
    getCalendarioFranquia,
    getEscalacaoDisputasPorCodigoCalendarioMandante,
    getEscalacaoDisputasPorCodigoCalendarioVisitante,
    getCalendarioQuantidadeRodadaPorTemporada,
    getCalendarioRodadasCopinhaPorTemporada,
    getCalendarioCopinhaPorCodigoLigaTemporada,
    getCalendarioCopinhaPorRodada,
    updateSorteioCopinhaById,
    getDadosCopinhaPorCodigoLigaTemporada,
    getClassificacaoCopinhaPorCodigoLigaTemporada

}